import styled from 'styled-components'

const Container = styled.div`
  position: relative;
  margin-bottom: ${(p) => p.theme.spacing.m};
  padding-left: 25px;
`

export default Container
